import React from 'react';
import {Heading} from "@chakra-ui/react";
import {Box, Text} from "@chakra-ui/layout";

export type Objective = {
  number: number;
  type: string;
}

function Objectives({number, type}: Objective) {
  return (
    <Box bgColor={"brand.orange"} borderRadius={10} padding={"15px"} m={"5px"}>
      <Heading>{number}</Heading>
      <Text fontSize={12} color={"brand.gold"}>{type}</Text>
    </Box>
  );
}

export default Objectives;